import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-qr-code-modal',
  standalone: true,
  templateUrl: './qr-code-modal.component.html',
  styleUrl: './qr-code-modal.component.scss',
})
export class QrCodeModalComponent {
  @Input() title: string | null = null;
  @Input() subtitle: string | null = null;
  @Input() qrCode: string | null = null;
  @Input() qrImageUrl: string | null = null;
  @Input() hasQrImage = false;
  @Input() canCopy = false;
  @Input() canExport = false;

  @Output() copyClicked = new EventEmitter<void>();
  @Output() exportClicked = new EventEmitter<void>();

  constructor(protected activeModal: NgbActiveModal) {}
}
